import {createDefaultLogger} from '@hconnect/common/logging'

// Add 'azure' as target for testing azure tracking locally
export const logger = createDefaultLogger('slot')
